import { render } from "./App.vue?vue&type=template&id=775b4203"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=775b4203&lang=scss"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__